import React from 'react';
import PropTypes from 'prop-types';
import Select from 'components/forms/Select';
import { CAMPAIGN_STATUS_OPTIONS } from 'constants/misc';


export default function CampaignStatusFilter(props) {
  return (<Select
    isMulti
    placeholder="Statuses"
    value={props.value}
    onChange={props.onChange}
    options={CAMPAIGN_STATUS_OPTIONS}
  />);
}

CampaignStatusFilter.propTypes = {
  value: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
};
